import { useCallback, useState } from "react";
import recordQueryStringUsage from "views/logic/queries/recordQueryStringUsage";
import useUserDateTime from "hooks/useUserDateTime";
import { isNoTimeRangeOverride } from "views/typeGuards/timeRange";
import { normalizeFromSearchBarForBackend } from "views/logic/queries/NormalizeTimeRange";
const _trim = (s) => s === void 0 ? void 0 : s.trim();
const useSearchBarSubmit = (initialValues, onSubmit) => {
  const { userTimezone } = useUserDateTime();
  const [enableReinitialize, setEnableReinitialize] = useState(true);
  const _onSubmit = useCallback(
    async (values) => {
      setEnableReinitialize(false);
      const { queryString, timerange, ...rest } = values;
      const trimmedQueryString = _trim(queryString);
      await recordQueryStringUsage(trimmedQueryString, _trim(initialValues == null ? void 0 : initialValues.queryString));
      try {
        return onSubmit({
          queryString,
          timerange: isNoTimeRangeOverride(timerange) ? void 0 : normalizeFromSearchBarForBackend(timerange, userTimezone),
          ...rest
        });
      } finally {
        setEnableReinitialize(true);
      }
    },
    [initialValues == null ? void 0 : initialValues.queryString, onSubmit, userTimezone]
  );
  return { enableReinitialize, onSubmit: _onSubmit };
};
export default useSearchBarSubmit;
